import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { HelpdeskService } from '../delavci/helpdesk.service';
import { HelpersService } from '../shared/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class UrediTaskGuard  {
  public dataRow;
  constructor(
    private router: Router, private helpersService: HelpersService, private helpdeskService: HelpdeskService, private route: ActivatedRoute) {
      this.helpdeskService.currentDataRow.subscribe(task => {
        this.dataRow = task;
      });
    }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(state.root.queryParams.zavihek) {
       /*console.log("modulId = " + state.root.queryParams.modulId);
       console.log("modulNameSmall = " + state.root.queryParams.modulNameSmall);
       console.log("serverCode = " + state.root.queryParams.serverCode);
       console.log("companyId = " + state.root.queryParams.companyId);*/
       return true;
     } else {
        let idTask = next.paramMap.get('idTask');
        this.router.navigate(["/uredi-task/" + idTask], { queryParams: { zavihek: 'description'} });
     }
  }

}
